export default __webpack_public_path__ + "static/media/login-logo.91e10bdc.png";